const api = "http://catastro.barranquilla.gov.co:8080/sky/historico";
export default api;